import { render, staticRenderFns } from "./iconBox.vue?vue&type=template&id=2deb8f20&scoped=true"
import script from "./iconBox.vue?vue&type=script&lang=js"
export * from "./iconBox.vue?vue&type=script&lang=js"
import style0 from "./iconBox.vue?vue&type=style&index=0&id=2deb8f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb8f20",
  null
  
)

export default component.exports